import { useReveal } from "@/hooks/useReveal";
import { photos, business } from "@/data/siteData";

export default function About() {
  const ref = useReveal();
  return (
    <section
      id="about"
      ref={ref}
      data-testid="about-section"
      className="relative py-20 md:py-28"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-20 items-center">
          <div className="lg:col-span-5 reveal">
            <div className="relative overflow-hidden">
              <img
                data-testid="about-image"
                src={photos.cappuccinoCroissant}
                alt="Cappuccino and croissant at Cafe Anh Helsinki"
                className="w-full h-[55vh] lg:h-[62vh] object-cover"
                loading="lazy"
              />
            </div>
            <p className="mt-4 text-[11px] tracking-[0.22em] uppercase text-[#5A7365]">
              {business.address}
            </p>
          </div>

          <div className="lg:col-span-7 lg:pl-8">
            <p className="reveal text-[11px] tracking-[0.32em] uppercase text-[#5A7365] mb-5">
              About us
            </p>
            <h2 className="reveal font-serif-display text-3xl sm:text-4xl lg:text-5xl text-[#132A1C] leading-[1.08] tracking-tight">
              A family-owned <span className="italic text-[#2C4C3B]">Vietnamese</span> café in the middle of Helsinki.
            </h2>
            <div className="reveal mt-9 grid grid-cols-1 sm:grid-cols-2 gap-7 text-[#2C4C3B] leading-relaxed">
              <p>
                We brew Vietnamese coffee the way it's brewed at home — strong,
                a little sweet, and made to be sat with. The bạc xỉu is gentle, the
                cà phê sữa đá is the real thing, and the egg coffee is poured warm.
              </p>
              <p>
                Alongside the coffee we cook a short Vietnamese menu: a clear,
                fragrant phở, banh mi on baguettes baked fresh, lemon tea for the
                bright days. A small space, friendly service — the kind of place
                you come back to.
              </p>
            </div>

            <div className="reveal mt-10 grid grid-cols-2 md:grid-cols-4 gap-5 border-t border-[#132A1C]/15 pt-8">
              {[
                [business.rating + "★", `${business.reviewsCount} reviews`],
                ["Dine-in", "& Takeaway"],
                [business.priceRange, "Per person"],
                ["Hämeentie 30", "Helsinki"],
              ].map(([k, v]) => (
                <div key={v}>
                  <div className="font-serif-display text-2xl md:text-3xl text-[#132A1C]">{k}</div>
                  <div className="mt-1 text-[11px] tracking-[0.18em] uppercase text-[#5A7365]">
                    {v}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
